import { setInitialAALoad as setInitialAALoadDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    value: boolean;
};

export const setInitialAALoad = ({
    value,
}: Props) => {
    setInitialAALoadDiagram(value);
};
